import ApiErrorMixin from '@/mixins/ApiErrorMixin'

export default {
  mixins: [ApiErrorMixin],

  data() {
    return {
      teamRequests: [],
      loadingTeamRequests: false,
      teamRequestsChannelName: null,
      teamRequestsListener: null,
      alertedTeamRequestIds: [],
    }
  },

  computed: {
    pendingTeamRequests() {
      return this.teamRequests.filter(r => r.status === 1)
    },

    // Tipos que o operador pode despachar sem justificar: o do pedido da regulação (se há pedido pendente) ou,
    // sem pedido, TODOS os sugeridos pelo interrogatório (antes só o primeiro valia, e um tipo sugerido
    // em segundo lugar era tratado como divergente).
    acceptedTeamTypes() {
      if (this.pendingTeamRequests.length) {
        return this.pendingTeamRequests.map(r => ({ id: r.team_type_id, name: r.team_type ? r.team_type.name : null }))
      }

      const suggested = (this.occurrence && this.occurrence.team_types) || []

      return suggested.map(t => ({ id: t.id, name: t.name }))
    },

    acceptedTeamTypeNames() {
      return this.acceptedTeamTypes.map(t => t.name).filter(Boolean).join(', ')
    },

    requestedTeamTypeSource() {
      return this.pendingTeamRequests.length ? 'regulacao' : 'interrogatorio'
    },
  },

  methods: {
    isAcceptedTeamType(typeId) {
      return this.acceptedTeamTypes.some(t => Number(t.id) === Number(typeId))
    },

    // O despacho atende o pedido pendente do tipo da equipe; sem um do mesmo tipo, o primeiro pendente.
    pendingRequestFor(team) {
      const pending = this.pendingTeamRequests

      return pending.find(r => Number(r.team_type_id) === Number(team.type_id)) || pending[0] || null
    },

    async loadTeamRequests(occurrenceId) {
      if (!occurrenceId) return
      this.loadingTeamRequests = true
      try {
        const res = await this.$http.get(`${this.$store.state.api}occurrence_team_requests`, {
          params: { occurrence_id: occurrenceId },
        })
        this.teamRequests = res.data.data || []
      } catch (e) {
        this.teamRequests = []
        this.$message('Erro', this.apiErrorText(e, 'Não foi possível carregar as solicitações de equipe.'), 'error')
      } finally {
        this.loadingTeamRequests = false
      }
    },

    watchTeamRequests() {
      if (typeof window.Echo === 'undefined') return

      const node = this.$store.state.selected_node
      if (!node || !node.id) return

      this.teamRequestsChannelName = `node.${node.id}`
      this.teamRequestsListener = payload => this.onTeamRequested(payload)

      window.Echo.private(this.teamRequestsChannelName)
        .listen('.TeamRequested', this.teamRequestsListener)
    },

    unwatchTeamRequests() {
      if (typeof window.Echo === 'undefined' || !this.teamRequestsChannelName) return

      // stopListening e nao leave(): o canal do no e compartilhado com as
      // posicoes da frota e com os eventos de despacho. leave() derrubava
      // todos ao sair desta tela.
      window.Echo.private(this.teamRequestsChannelName)
        .stopListening('.TeamRequested', this.teamRequestsListener)

      this.teamRequestsChannelName = null
      this.teamRequestsListener = null
    },

    onTeamRequested(payload) {
      if (!payload || !payload.id) return
      if (this.alertedTeamRequestIds.includes(payload.id)) return
      this.alertedTeamRequestIds.push(payload.id)

      const current = this.occurrence ? this.occurrence.id : null
      const isCurrent = current && Number(payload.occurrence_id) === Number(current)

      if (isCurrent) this.loadTeamRequests(current)

      this.playTeamRequestAlert()

      const label = payload.quantity > 1
        ? `${payload.quantity}x ${payload.team_type_name || 'equipe'}`
        : (payload.team_type_name || 'equipe')

      this.$message(
        'Solicitação de equipe',
        `A regulação solicitou ${label
        }${isCurrent ? '.' : ` na ocorrência #${payload.occurrence_id}.`}`,
        'warning',
      )

      this.$emit('team-request-received', payload)
    },

    playTeamRequestAlert() {
      try {
        const Ctx = window.AudioContext || window.webkitAudioContext
        if (!Ctx) return

        const ctx = new Ctx()
        const play = (freq, startAt, duration) => {
          const osc = ctx.createOscillator()
          const gain = ctx.createGain()
          osc.type = 'sine'
          osc.frequency.value = freq
          gain.gain.setValueAtTime(0.0001, ctx.currentTime + startAt)
          gain.gain.exponentialRampToValueAtTime(0.25, ctx.currentTime + startAt + 0.02)
          gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + startAt + duration)
          osc.connect(gain)
          gain.connect(ctx.destination)
          osc.start(ctx.currentTime + startAt)
          osc.stop(ctx.currentTime + startAt + duration)
        }

        play(880, 0, 0.18)
        play(1175, 0.2, 0.28)

        setTimeout(() => ctx.close(), 1200)
      } catch (e) {
      }
    },
  },

  beforeDestroy() {
    this.unwatchTeamRequests()
  },
}
